import { MobileOrderConfirmationModalComponent } from './../mobile-order-confirmation-modal/mobile-order-confirmation-modal.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { TradeRequestModel } from "../../../model/trade.request.data";

import { LastTradeData } from "../orderentry/orderentry.component";

import { OrderConfirmationModal } from "./orderconfirmation.component";

export function ShowOrderConfirmationModal(modalService: NgbModal, tradeData:TradeRequestModel, ticketToCancel?: string, lastTradeInformation?:LastTradeData, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileOrderConfirmationModalComponent: OrderConfirmationModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<OrderConfirmationModal>m.componentInstance);
    modal.tradeData = tradeData;
    modal.ticketToCancel = ticketToCancel;
    modal.lastTradeInformation = lastTradeInformation;
    return modal;
}
